import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CommissionAdjustDisposition, CommissionDispositionDetail } from 'src/app/model/other-catalogs-models';
import { AuthService } from 'src/app/services/auth.service';
import { CommissionSalePromotionsService } from 'src/app/services/commission-sale-promotions.service';
import { ModalCommissionAdjustDispositionComponent } from 'src/oldApp/shared/modal-commission-disposition/modal-commission-adjust-disposition/modal-commission-adjust-disposition.component';
import { ModalConfirmComponent } from 'src/oldApp/shared/modal-confirm/modal-confirm.component';

@Component({
  selector: "app-modal-commission-disposition",
  templateUrl: "./modal-commission-disposition.component.html",
  styleUrls: ["./modal-commission-disposition.component.css"],
})
export class ModalCommissionDispositionComponent implements OnInit {
  @Input() listCommissionDispositionDetail: CommissionDispositionDetail[] = [];
  @Input() enviado: number[] = [];
  role: string = '';

  public userId = Number(localStorage.getItem("com_token"));

  public mode: string;
  public title: string;
  public fechaCobro: string;
  public fechaInicio: string;
  public fechaFin: string;
  public fechaEjecucion: string;
  public accion: number;
  public sessionId: string;

  constructor(
    private commissionSalePromotionsService: CommissionSalePromotionsService,
    private toastr: ToastrService,
    private modalService: NgbModal,
    private auth: AuthService
  ) { }

  dtOptions = {
    order: [],
    responsive: true,

    select: "single",
    bLengthChange: true,
    searching: true,
    dom: '<"row"<"col"B><"col"<"text-center">><"col"f>><"row"<"col"t>><"row"<"col"p>>',
    buttons: ["csv", "excel"],
    autoWidth: true,
    columnDefs: [
      { responsivePriority: 1, targets: 0 },
      { responsivePriority: 5, targets: -1 },
    ],
    pageLength: 5,
    language: {
      processing: "Procesando...",
      search: "Buscar:",
      lengthMenu: "Mostrar _MENU_ elementos",
      info: "Mostrando del _START_ al _END_ de _TOTAL_ elementos",
      infoEmpty: "Mostrando ningún elemento.",
      infoFiltered: "(filtrado _MAX_ elementos total)",
      infoPostFix: "",
      loadingRecords: "Cargando registros...",
      zeroRecords: "No se encontraron registros",
      emptyTable: "No hay datos disponibles en la tabla",
      paginate: {
        first: "Primero",
        previous: "Anterior",
        next: "Siguiente",
        last: "Último",
      },
      aria: {
        sortAscending: ": Activar para ordenar la tabla en orden ascendente",
        sortDescending: ": Activar para ordenar la tabla en orden descendente",
      },
      // dom: 'Bfrtip',
      buttons: ["excel"],
    },
  };

  ngOnInit() {
    this.role = localStorage.getItem('com_role');
    this.title = "DETALLE AGRUPADO POR ASESOR";

    this.fechaInicio = this.listCommissionDispositionDetail[0].fechaInicio;
    this.fechaFin = this.listCommissionDispositionDetail[0].fechaFin;
    this.fechaEjecucion = this.listCommissionDispositionDetail[0].executionDate;
    this.sessionId = this.listCommissionDispositionDetail[0].sessionId;
    this.fechaCobro = this.listCommissionDispositionDetail[0].FechaCobro;

    console.log("Fecha Inicio: ", this.fechaInicio);
    console.log("Fecha Fin: ", this.fechaFin);
    console.log("Fecha Cobro: ", this.fechaCobro);
    console.log("SessionId: ", this.sessionId);
    console.log("Fecha Ejecucion: ", this.fechaEjecucion);

    let modalContent: any = $(".modal-content");
    modalContent.draggable({ handle: ".card-header" });
  }

  close = () => {
    this.modalService.dismissAll();
  };

  openAdjustCommissionDisposition(
    ClaveEmpleadoDispersion: string,
    comisionTotal: number,
    ajusteComision: number,
    comisionFinal: number
  ) {
    let CommissionAdjustDisposition: CommissionAdjustDisposition = {
      ClaveEmpleadoDispersion: {},
      comisionTotal: {},
      ajusteComision: {},
      comisionFinal: {},
      userCreate: {},
      createDate: {},
      status: {},
      Nota: {},
    } as CommissionAdjustDisposition;
    CommissionAdjustDisposition.ClaveEmpleadoDispersion =
      ClaveEmpleadoDispersion;
    CommissionAdjustDisposition.comisionTotal = comisionTotal;
    CommissionAdjustDisposition.ajusteComision = ajusteComision;
    CommissionAdjustDisposition.comisionFinal = comisionFinal;
    CommissionAdjustDisposition.Nota = "";
    console.warn(CommissionAdjustDisposition);

    let modalRef = this.modalService.open(
      ModalCommissionAdjustDispositionComponent,
      { centered: true, size: "lg", backdrop: "static" }
    );

    modalRef.componentInstance.CommissionAdjustDisposition =
      CommissionAdjustDisposition;
    modalRef.result.then(
      (data) => console.log(">> DATA: " + data),
      (reason) => {
        console.log(">> JSON CREDITO: " + JSON.stringify(reason));
      }
    );
  }

  modalWarning() {
    let _text = "<br><br><br>¡Se marcarán las <b>Comisiones</b> de manera irreversible como pagadas! <br>¿Está seguro de pagar las <b>Comisiones</b>?";

    let modalRef = this.modalService.open(ModalConfirmComponent, {
      centered: true,
      size: "sm",
      backdrop: "static",
      keyboard: false,
    });
    modalRef.componentInstance.header = " ¿Desea marcar como pagadas? ";
    modalRef.componentInstance.text = _text;
    modalRef.componentInstance.viewHeader = 0;
    modalRef.componentInstance.acceptText = "Sí, marcar";
    modalRef.componentInstance.cancelText = "Cancelar";
    modalRef.result.then(
      (data) => console.log(data),
      (reason) => {
        if (reason === "accept") {
          this.SendCanePayments();
        }
      }
    );
  }

  SendCanePayments = () => {
    this.commissionSalePromotionsService
      .SendCaneDisposition({
        fechaInicio: this.fechaInicio,
        fechaFin: this.fechaFin,
        fechaCobro: this.fechaCobro,
        fechaEjecucion: this.fechaEjecucion,
        sessionId: this.sessionId,
        userId: this.userId
      })
      .pipe(
        tap((resp: any) => {
          this.listCommissionDispositionDetail = resp.data;
          console.log(this.listCommissionDispositionDetail);
          this.toastr.success("Las comisiones se han enviado con éxito.");
          this.modalService.dismissAll();
        }),
        catchError((error) => {
          console.log(error);

          return of(
            this.toastr.error("Ocurrió un error al enviar las commisiones")
          );
        })
      )
      .subscribe();
  };
}
